import React from "react";
import { connect } from "react-redux";
import { getFormValues, Field, SubmissionError, reduxForm } from "redux-form";
import { Collapse } from "@material-ui/core";
import { Button } from "semantic-ui-react";
import { toastError } from "ducks/app";
import { getStampDutyOptions, getPrSpecialOptions } from "ducks/options";
import { getRFQByCollNum, rfqUnlock, reloadRFQByCollNum } from "ducks/rfq";
import { scrollToFirstValidateFailElement } from "core/utilities";
import FieldInput, { InputType as type } from "components/SemanticForm";
import { RFQContainer } from "routes/ProcurementSystem/RequestForQuotation/styled";
import { lower } from "change-case";

const Collective = (props) => {
  const {
    isCreate = false,
    isEdit = false,
    valueForm,
    rfqGoaItems,
    rfqUnlockStatus,
    isDetail = false,
  } = props;

  React.useEffect(() => {
    if (
      props.stampDutyOptions.loading === false &&
      props.stampDutyOptions.data.length === 0
    ) {
      props.getStampDutyOptions();
    }
  }, []);

  React.useEffect(() => {
    if (valueForm.isSpecialPr) {
      props.getPrSpecialOptions("Special");
    } else if (valueForm.isAffiliatedCompanies) {
      props.getPrSpecialOptions("AffiliatedCompanies");
    } else if (valueForm.isPartnersPreQualified) {
      props.getPrSpecialOptions("PartnersPreQualified");
    }
  }, [
    valueForm.special,
    valueForm.isAffiliatedCompanies,
    valueForm.isPartnersPreQualified,
  ]);

  const submitGetRFQByCN = () => {
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    return sleep(100).then(() => {
      let error = {};
      if (
        !valueForm.collectiveNumber ? true : !valueForm.collectiveNumber.trim()
      ) {
        error.collectiveNumber = "Required!";
      }
      if (Object.keys(error).length) {
        scrollToFirstValidateFailElement(error);
        throw new SubmissionError(error);
      } else {
        if (isCreate) {
          props.getRFQByCollNum(valueForm.collectiveNumber.trim());
        } else if (isEdit) {
          if (rfqUnlockStatus) {
            props.reloadRFQByCollNum(valueForm.collectiveNumber.trim());
          } else {
            props.toastError("Please unlock RFQ before reload data");
          }
        }
      }
    });
  };

  const getSpecialReasonOption = (specialReason) => {
    return props.prSpecial.data.find(
      (x) => x.value === (specialReason || valueForm.specialPrReason || ""),
    );
  };

  return (
    <RFQContainer>
      <div className="rowFields">
        <Field
          name="collectiveNumber"
          label="Collective Number"
          type={type.text}
          component={FieldInput}
          className="halfRow"
          require
          editable={isCreate}
        />
        <div className="collectiveButtons">
          {(isCreate || isEdit) && (
            <Button
              type="button"
              color="blue"
              onClick={props.handleSubmit(() => submitGetRFQByCN())}
            >
              {valueForm && valueForm.id ? "Reload Data" : "Load Data"}
            </Button>
          )}
          {isEdit && (
            <Button
              type="button"
              color="yellow"
              disabled={rfqUnlockStatus}
              onClick={() => props.rfqUnlock(valueForm ? valueForm.id : "")}
            >
              Unlock SAP
            </Button>
          )}
        </div>
      </div>
      <div className="rowFields">
        <Field
          name="goaItemCode"
          label="RFQ By GOA"
          require
          allowAdditions={false}
          options={rfqGoaItems.data}
          loading={rfqGoaItems.loading}
          type={type.select}
          component={FieldInput}
          editable={isCreate || isEdit}
        />
        <Field
          name="alternativePurchaseUser"
          label="Procurement Reviewer"
          type={type.selectwithnull}
          allowAdditions={false}
          options={
            isDetail
              ? props.members.map((m, i) => ({
                  key: i,
                  value: lower(m.username),
                  text: `${m.firstnameEn} ${m.lastnameEn}`,
                }))
              : props.purchaseUsers.data.map((x) => ({
                  value: x.username,
                  text: `${x.firstnameEn} ${x.lastnameEn}`,
                }))
          }
          loading={
            isDetail ? props.members.loading : props.purchaseUsers.loading
          }
          component={FieldInput}
          editable={isCreate || isEdit}
        />
      </div>
      <div className="rowFields">
        <Field
          require
          name="stampDutyType"
          label="Type Stamp Duty"
          type={type.select}
          options={props.stampDutyOptions.data}
          component={FieldInput}
          editable={isCreate || isEdit}
        />
        <Field type={type.empty} component={FieldInput} />
      </div>
      <Collapse in={valueForm && valueForm.status >= 0} timeout={500}>
        <div className="rowFields">
          <Field
            name="companyCode"
            label="Company"
            type={type.select}
            allowAdditions={false}
            options={props.companies.data}
            loading={props.companies.loading}
            component={FieldInput}
            editable={false}
          />
          <Field
            name="projectId"
            label="Project Name"
            allowAdditions={false}
            loading={props.projectLoading}
            options={props.projectOptions}
            type={type.select}
            component={FieldInput}
            editable={false}
          />
        </div>
        <div className="rowFields">
          <Field
            name="purchasingGroup"
            label="Purchasing Group"
            type={type.select}
            allowAdditions={false}
            options={props.purchasingGroups.data}
            loading={props.purchasingGroups.loading}
            component={FieldInput}
            editable={false}
            className="halfRow"
          />
        </div>
        <div className="rowFields">
          <Field
            name="priority"
            label="Priority"
            options={[
              { title: "Normal", value: "normal", color: "blue" },
              { title: "Urgent", value: "urgent", color: "red" },
            ]}
            type={type.tabSelection}
            component={FieldInput}
            editable={isCreate || isEdit}
            require
          />
          <Field
            name="isContract"
            label="Contract"
            type={type.switch}
            component={FieldInput}
            editable={
              isCreate || isEdit
                ? !(valueForm
                    ? valueForm.purchaseOrderNumber
                      ? ["43", "44", 43, 44].indexOf(
                          valueForm.purchaseOrderNumber.substring(0, 2),
                        ) >= 0
                      : false
                    : false)
                : false
            }
          />
        </div>
        <div className="rowFields">
          <Field
            name="isSpecialPr"
            label="Special PR"
            type={type.switch}
            component={FieldInput}
            editable={false}
          />
        </div>
        <Collapse in={valueForm && valueForm.isSpecialPr} timeout={500}>
          {(valueForm.specialPrReason || "").startsWith("SP") &&
          (valueForm.specialPrReason || "").length === 4 ? (
            <React.Fragment>
              <div className="rowFields">
                <Field
                  require
                  name="specialPrReason"
                  label="Reason"
                  type={type.select}
                  options={props.prSpecial.data}
                  editable={false}
                  component={FieldInput}
                />
              </div>
              {valueForm.specialPrReason === "SP04" ? (
                <div className="rowFields">
                  <Field
                    name="subSpecialPrReason"
                    type={type.select}
                    options={(getSpecialReasonOption() || {}).subOptions || []}
                    editable={false}
                    component={FieldInput}
                  />
                </div>
              ) : null}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="rowFields">
                <Field
                  name="specialPrTitle"
                  require
                  label="Special PR Title"
                  type={type.text}
                  component={FieldInput}
                  editable={isCreate || isEdit}
                />
              </div>
              <div className="rowFields">
                <Field
                  require
                  name="specialPrReason"
                  label="Special PR Reason"
                  placeHolder="ระบุเหตุผลที่เลือก Vendor มีคุณสมบัติเฉพาะเจาะจงอย่างไร เช่น เป็นรายเดียวสามารถส่งมอบสินค้าหรือบริการนั้นได้ และตรงกับความต้องการ"
                  type={type.textArea}
                  component={FieldInput}
                  editable={isCreate || isEdit}
                />
              </div>
              <div className="rowFields" style={{ marginButton: "1rem" }}>
                {isCreate || isEdit ? null : (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div>Special PR Attachment</div>
                    {valueForm.rfqSpecialPrAttachments &&
                      valueForm.rfqSpecialPrAttachments.map((x) => (
                        // <Button style={{marginTop:'0.1rem'}} type='button' content={<div className='fileNameContent'>{x.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.open(x.urlPath,'_blank'))}/>
                        <Button
                          style={{ marginTop: "0.1rem" }}
                          type="button"
                          content={
                            <div className="fileNameContent">
                              {x.originalFilename}
                            </div>
                          }
                          icon="download"
                          labelPosition="left"
                          onClick={() => (window.location.href = x.urlPath)}
                        />
                      ))}
                  </div>
                )}
              </div>
            </React.Fragment>
          )}
        </Collapse>
        <div className="rowFields">
          <Field
            name="isAffiliatedCompanies"
            label="Affiliated Companies"
            type={type.switch}
            component={FieldInput}
            editable={false}
          />
        </div>
        <Collapse
          in={valueForm && valueForm.isAffiliatedCompanies}
          timeout={500}
        >
          <div className="rowFields">
            <Field
              require
              name="affiliatedCompaniesReason"
              label="Reason"
              type={type.select}
              options={props.prSpecial.data}
              editable={false}
              component={FieldInput}
            />
          </div>
        </Collapse>
        <div className="rowFields">
          <Field
            name="isPartnersPreQualified"
            label="Partners(Pre-Qualified)"
            type={type.switch}
            component={FieldInput}
            editable={false}
          />
        </div>
        <Collapse
          in={valueForm && valueForm.isPartnersPreQualified}
          timeout={500}
        >
          <div className="rowFields">
            <Field
              require
              name="partnersPreQualifiedReason"
              label="Reason"
              type={type.select}
              options={props.prSpecial.data}
              editable={false}
              component={FieldInput}
            />
          </div>
        </Collapse>
        <div className="rowFields" style={{ marginTop: "1rem" }}>
          <Field
            name="isAdditionalPr"
            label="Additional PR"
            type={type.switch}
            component={FieldInput}
            editable={false}
          />
        </div>
        <Collapse in={valueForm && valueForm.isAdditionalPr} timeout={500}>
          <div className="rowFields">
            <Field
              require
              name="additionalPrReason"
              label="Additional Detail"
              placeHolder="ระบุเหตุผลสำหรับ PR งานเพิ่ม"
              type={type.textArea}
              component={FieldInput}
              editable={false}
            />
          </div>
          <div className="rowFields">
            <Field
              require
              name="additionalRefPoNumber"
              label="Reference SAP PO (Original) No"
              placeHolder="Example 4100022298 ,4300001301"
              type={type.text}
              component={FieldInput}
              editable={false}
            />
            <Field
              name="additionalContractNumber"
              label="Reference Contract No"
              type={type.text}
              component={FieldInput}
              editable={false}
            />
          </div>
        </Collapse>
      </Collapse>
    </RFQContainer>
  );
};

const mapStateToProps = (state) => {
  const valueForm = getFormValues("formRFQ")(state) || {};
  //set project options
  var projectOptions = [];
  if (
    valueForm.companyCode &&
    state.goa.projects &&
    state.goa.projects[valueForm.companyCode]
  ) {
    projectOptions = state.goa.projects[valueForm.companyCode].map((p) => {
      return { value: p.id, text: p.projectName };
    });

    if (state.goa.projects.other) {
      state.goa.projects.other.forEach((p) => {
        projectOptions.push({ value: p.id, text: p.projectName });
      });
    }
  }
  // set GOA options
  var GOAOptions = [];
  if (state.goa.goas.data.length && !state.goa.loading) {
    GOAOptions = state.goa.goas.data.map((p) => {
      return { value: `${p.id}`, text: p.name };
    });
  }
  return {
    valueForm,
    purchasingGroups: state.options.purchasingGroups,
    companies: state.options.companies,
    stampDutyOptions: state.options.stampDuty,
    projectOptions,
    projectLoading: state.goa.projectLoading,
    GOAOptions,
    GOALoading: state.goa.goas.loading,
    rfqUnlockStatus: state.rfq.rfqUnlockStatus,
    rfqGoaItems: state.rfq.rfqGoaItems,
    purchaseUsers: state.member.purchaseUsers,
    prSpecial: state.options.prSpecial,
    members: state.member.members,
  };
};

const mapDispatchToProps = {
  getRFQByCollNum,
  reloadRFQByCollNum,
  rfqUnlock,
  toastError,
  getStampDutyOptions,
  getPrSpecialOptions,
};

const contForm = reduxForm({
  form: "formRFQ",
  enableReinitialize: true,
  destroyOnUnmount: false,
})(Collective);

export default connect(mapStateToProps, mapDispatchToProps)(contForm);
